import { render, staticRenderFns } from "./SuppliesTableMobile.vue?vue&type=template&id=16d0798a&scoped=true&lang=pug"
import script from "./SuppliesTableMobile.vue?vue&type=script&lang=js"
export * from "./SuppliesTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d0798a",
  null
  
)

export default component.exports